if (!customElements.get('pp-home-reviews')) {
  customElements.define('pp-home-reviews', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.pp-review-rail');
      this.toggle = this.querySelector('[data-review-toggle]');
      if (!this.rail || !this.toggle) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovering = false;
      this.focused = false;
      this.previousTime = null;
      this.position = this.rail.scrollLeft;
      this.querySelector('.pp-review-controls').hidden = false;
      this.syncToggle();
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.position = this.rail.scrollLeft;
        this.syncToggle();
      }, options);
      this.querySelector('[data-review-prev]').addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-review-next]').addEventListener('click', () => this.move(1), options);
      this.rail.addEventListener('pointerenter', () => { this.hovering = true; }, options);
      this.rail.addEventListener('pointerleave', () => { this.hovering = false; this.position = this.rail.scrollLeft; }, options);
      this.rail.addEventListener('focusin', () => { this.focused = true; }, options);
      this.rail.addEventListener('focusout', () => { this.focused = false; this.position = this.rail.scrollLeft; }, options);
      for (const event of ['pointerdown', 'wheel', 'keydown']) {
        this.rail.addEventListener(event, () => { this.paused = true; this.syncToggle(); }, options);
      }
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) { this.paused = true; this.syncToggle(); }
      }, options);
      this.frame = requestAnimationFrame((time) => this.tick(time));
    }
    syncToggle() {
      this.toggle.textContent = this.paused ? 'Resume scrolling' : 'Pause scrolling';
      this.toggle.setAttribute('aria-pressed', String(this.paused));
    }
    move(direction) {
      this.paused = true;
      this.syncToggle();
      const card = this.rail.querySelector('.pp-review-card');
      const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).gap);
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      let target = this.rail.scrollLeft + direction * distance;
      if (target > max + 1) target = 0;
      if (target < -1) target = max;
      this.rail.scrollTo({ left: target, behavior: this.motion.matches ? 'instant' : 'smooth' });
      this.position = target;
    }
    tick(time) {
      const elapsed = this.previousTime === null ? 0 : Math.min(time - this.previousTime, 64);
      this.previousTime = time;
      const bounds = this.getBoundingClientRect();
      if (!this.paused && !this.hovering && !this.focused && !document.hidden && bounds.bottom > 0 && bounds.top < window.innerHeight) {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        // 24px/second matches 0.4px/frame at 60Hz without depending on monitor refresh rate.
        this.position += elapsed * 0.024;
        if (this.position >= max) this.position = 0;
        this.rail.scrollLeft = this.position;
      }
      this.frame = requestAnimationFrame((next) => this.tick(next));
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}
